import { type ApiEnvelope, api, unwrap } from "@/lib/api";

export type CalendarKind =
	| "banner"
	| "newsletter"
	| "push"
	| "whatsapp"
	| "article";

export interface CalendarEvent {
	id: string;
	kind: CalendarKind;
	title: string;
	at: string;
	status: string;
}

export interface MarketingOverview {
	kpis: {
		activeBanners: number;
		bannerCtr: number;
		publishedArticles: number;
		articleViews: number;
		subscribers: number;
		openRate: number;
	};
	channels: Array<{ key: string; label: string; engagement: number }>;
	/** Canaux dont la chaîne technique est incomplète : à dire, pas à cacher. */
	readiness: { push: boolean; whatsapp: boolean };
	upcoming: CalendarEvent[];
}

export const marketingHubApi = {
	overview: () =>
		unwrap<MarketingOverview>(
			api.get<ApiEnvelope<MarketingOverview>>("/admin/marketing/hub/overview"),
		),

	calendar: (month: string) =>
		unwrap<{ month: string; events: CalendarEvent[] }>(
			api.get<ApiEnvelope<{ month: string; events: CalendarEvent[] }>>(
				"/admin/marketing/hub/calendar",
				{ params: { month } },
			),
		),
};

/** Couleur et destination de chaque nature d'événement du calendrier. */
export const KIND_META: Record<
	CalendarKind,
	{ label: string; tone: "terra" | "forest" | "ochre" | "info"; to: string }
> = {
	banner: { label: "Bannière", tone: "forest", to: "/marketing/bannieres" },
	newsletter: { label: "Newsletter", tone: "terra", to: "/marketing/newsletters" },
	push: { label: "Push", tone: "ochre", to: "/marketing/push" },
	whatsapp: { label: "WhatsApp", tone: "forest", to: "/marketing/whatsapp" },
	article: { label: "Article", tone: "info", to: "/marketing/mag" },
};
